import axios from "axios";
import apiUrlOne from "../../utils.js/Config";

export const getFeaturedLogos = async () => {
    try {
        const response = await axios.get(`${apiUrlOne}/featured/admin`);
        return response.data;
    } catch (error) {
        console.error("Error fetching featured logos:", error);
        throw error;
    }
};

export const createFeaturedLogo = async (formData) => {
    try {
        const response = await axios.post(`${apiUrlOne}/featured`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error creating featured logo:", error);
        throw error;
    }
};

export const updateFeaturedLogo = async (id, formData) => {
    try {
        const response = await axios.put(`${apiUrlOne}/featured/${id}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error updating featured logo:", error);
        throw error;
    }
};

export const deleteFeaturedLogo = async (id) => {
    try {
        const response = await axios.delete(`${apiUrlOne}/featured/${id}`);
        return response.data;
    } catch (error) {
        console.error("Error deleting featured logo:", error);
        throw error;
    }
};